import "./Method.css";
import { useT } from "@/i18n/context";

export function Method() {
  const t = useT();
  return (
    <section id="method" className="section method">
      <div className="container">
        <h2 className="section__heading">{t.method.heading}</h2>
        <div className="method__content" data-reveal="">
          <p className="method__intro">{t.method.intro}</p>
          <div className="method__grid">
            {t.method.steps.map((step) => (
              <div key={step.number} className="method__step">
                <span className="method__number">{step.number}</span>
                <h3 className="method__title">{step.title}</h3>
                <p className="method__desc">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Method;
